import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import './Header.css'
import logoImage from '../../assets/logo_with_label.png'
import type { BranchInfo } from '../../types'

interface HeaderProps {
  branch?: BranchInfo | null
}

export default function Header({ branch }: HeaderProps) {
  const { t, i18n } = useTranslation()
  const [branchLogoFailed, setBranchLogoFailed] = useState(false)

  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language === 'ru' ? 'en' : 'ru')
  }

  const langSwitcher = (
    <button className="header__lang-switcher" onClick={toggleLanguage}>
      {i18n.language === 'ru' ? 'EN' : 'RU'}
    </button>
  )

  // Без ДЦ — шапка Verrafied как раньше
  if (!branch) {
    return (
      <header className="header">
        <img
          src={logoImage}
          alt="VERRAFIED AI"
          className="header__logo"
        />
        {langSwitcher}
      </header>
    )
  }

  const showBranchLogo = !!branch.logoUrl && !branchLogoFailed

  return (
    <header className="header header--branded">
      {showBranchLogo ? (
        <img
          src={branch.logoUrl!}
          alt={branch.name}
          className="header__branch-logo"
          onError={() => setBranchLogoFailed(true)}
        />
      ) : (
        <span className="header__branch-name">{branch.name}</span>
      )}
      <span className="header__powered">
        {t('app.powered_by')}
        <img src={logoImage} alt="VERRAFIED AI" className="header__powered-logo" />
      </span>
      {langSwitcher}
    </header>
  )
}
